import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

interface IGetNewsLetterPosts {
  facility_id: number;
}

export interface INewsLetterSubscriber {
    id: number;
    facility_id: number;
    customer_id: number;
    subscribed: boolean;
}

export async function GetNewsLetterSubscriber(params: IGetNewsLetterPosts, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet<INewsLetterSubscriber>(APIUrl(AdminType.Customer, "/facility/news-letter/subscriber"), params, useGlobalLoader, cancelToken);
}

export async function PostNewsLetterSubscriber(params: {facility_id: number}, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.Customer, "/facility/news-letter/subscriber"), params, useGlobalLoader);
  }

  export async function PutNewsLetterSubscriber(params: {facility_id: number, subscribed: boolean}, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.Customer, "/facility/news-letter/subscriber"), params, useGlobalLoader);
  }